var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isMounted
    ? _c("div", { staticClass: "cookie-bar bg-white w-100 mx-100" }, [
        _vm.isVisible && !_vm.showModal
          ? _c(
              "div",
              { staticClass: "cookie-bar-wrapper px-3 px-md-4 py-4" },
              [
                _vm._t("content"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-lg-3 d-flex align-items-center justify-content-between flex-column flex-lg-row",
                  },
                  [
                    _vm._t("links"),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex cookie-buttons flex-column-reverse flex-sm-row mt-3 mt-lg-0",
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn cookie-bar-btn text-white text-center w-100",
                            on: { click: _vm.acceptAllConsent },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.multiLanguage.CookieBarAcceptAll) +
                                "\n        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn bg-white text-dark cookie-bar-btn cookie-bar-reject-btn text-center w-100",
                            on: { click: _vm.denyAllConsent },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.multiLanguage.CookieBarDenyAll) +
                                "\n        "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-primary bg-white cookie-bar-link",
                            on: { click: _vm.openModal },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.multiLanguage.CookieBarPreferences) +
                                "\n        "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  2
                ),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showModal
          ? _c("div", { staticClass: "custom-modal-overlay" }, [
              _c("div", { staticClass: "custom-modal-content bg-white" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "custom-modal-header d-flex align-items-center justify-content-between",
                  },
                  [
                    _c("h4", [
                      _vm._v(_vm._s(_vm.multiLanguage.CookieBarTitle)),
                    ]),
                    _vm._v(" "),
                    _c("button", { on: { click: _vm.closeModal } }, [
                      _vm._v("×"),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "custom-modal-body my-3" }, [
                  _c("p", { staticClass: "small" }, [
                    _vm._v(_vm._s(_vm.multiLanguage.CookieBarDescription)),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex align-items-center mt-1" }, [
                    _c(
                      "a",
                      {
                        staticClass: "d-block text-underline small",
                        attrs: { target: "_blank", href: _vm.privacyPolicyUrl },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.footerPrivacyPolicy"
                              )
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "d-block ml-3 text-underline small",
                        attrs: {
                          target: "_blank",
                          href: _vm.legalDisclosureUrl,
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$translate(
                                "Ceres::Template.footerLegalDisclosure"
                              )
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cookie-content-table my-2" },
                    [
                      _c("consent-list", {
                        attrs: { consentGroups: _vm.consentGroups },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-start cookie-buttons flex-column-reverse flex-sm-row",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-primary cookie-bar-link text-center w-100",
                        on: { click: _vm.acceptSelection },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.multiLanguage.CookieBarAcceptSelection) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary cookie-bar-btn w-100",
                        on: { click: _vm.acceptAllConsent },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.multiLanguage.CookieBarAcceptAll) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }